<template>
  <b-form @submit="onSubmit">
    <b-form-row class="mb-2">
      <b-col class="d-flex align-items-center">
        <h4>История списаний</h4>
      </b-col>
    </b-form-row>
    <b-form-row class="mb-2">
      <b-col>
        <b-button size="sm" variant="outline-primary" type="submit">Искать</b-button>
      </b-col>
      С
      <b-col class="col-3">
        <b-form-input size="sm" type="date" v-model="from_date"/>
      </b-col>
      по
      <b-col class="col-3">
        <b-form-input size="sm" type="date" v-model="to_date"/>
      </b-col>
    </b-form-row>
    <b-table
            id="my-table"
            :items="items"
            :per-page="perPage"
            :current-page="currentPage"
            class="align-items-center text-nowrap"
            responsive
            :striped="false"
            :sticky-header="true"
            style="min-height: 40vh; max-height: 65vh"
            :no-border-collapse="true"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :filter="filter"
            :sort-by="'created'"
            :sort-desc="true">
          <template #head(created)>
            <div class="text-nowrap">Дата</div>
          </template>
          <template #head(inn)>
            <div class="text-nowrap">ИНН</div>
          </template>
          <template #head(tarif_id)>
            <div class="text-nowrap">Тариф</div>
          </template>
          <template #cell(tarif_id)="row">
            {{ tariff_table[row.item.tarif_id] }}
          </template>
          <template #head(balance_start)>
            <div class="text-nowrap">Остаток<br>утро, ₽</div>
          </template>
          <template #head(connections)>
            <div class="text-nowrap">Кол-во<br>соединений</div>
          </template>
          <template #head(connection_billable)>
            <div class="text" aria-multiline="true">
              Кол-во тарифи-<br>цируемых<br>соединений
            </div>
          </template>
          <template #head(billing_summ)>
            <div class="text-nowrap">∑ за день, ₽</div>
          </template>
          <template #head(balance_end)>
            <div class="text-nowrap">Остаток<br>вечер, ₽</div>
          </template>
          <template #head(connections_month)>
            <div class="text-nowrap">Кол-во<br>тарифицируемых<br>соединений<br>в месяц</div>
          </template>
        </b-table>
    <b-form-row class="mb-2">
      <b-col>
        <b-row class="align-items-center ml-0">
          <span class="hp-placeholder mr-2">Строк на страницу</span>
          <b-form-select size="sm" class="col-3 float-left" v-model="perPage" @input="updateTable">
            <b-form-select-option :value="10">10</b-form-select-option>
            <b-form-select-option :value="50">50</b-form-select-option>
            <b-form-select-option :value="100">100</b-form-select-option>
            <b-form-select-option :value="200">200</b-form-select-option>
          </b-form-select>
        </b-row>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          size="sm">
        </b-pagination>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import {
  BTable,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BFormSelect,
  BInputGroup,
  BButton,
  BFormInput,
  BInputGroupAppend,
  BFormDatepicker,
  BFormRow,
  BCol,
  BRow,
  BPagination,
  BDropdown,
  BDropdownItem,
  BFormSelectOption,
} from "bootstrap-vue";

import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      fields: [""],
      items: [""],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      small: false,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: "",
      noCollapse: false,
      filter: "",
      from_date: null,
      to_date: null,
      tariff_table: null,

      currentPage: 1,
      perPage: this.getRowsPerPageFromStorage(),
      rows: 0,
    };
  },
  components: {
    BCol,
    BRow,
    BTable,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckbox,
    BFormSelect,
    BInputGroup,
    BButton,
    BFormInput,
    BInputGroupAppend,
    BFormDatepicker,
    BFormRow,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelectOption,
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.updateTable();
    },
    async updateTable() {
      this.saveRowsPerPage();
      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }

      const { data } = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/billing/${inn}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            from_date: this.from_date,
            to_date: this.to_date,
          },
        }
      );
      console.log(data);

      this.fields = [
        { key: "created", sortable: true },
        { key: "inn", sortable: true },
        { key: "tarif_id", sortable: true },
        { key: "balance_start", sortable: true },
        { key: "connections", sortable: true },
        { key: "connection_billable", sortable: true },
        { key: "billing_summ", sortable: true },
        { key: "balance_end", sortable: true },
        { key: "connections_month", sortable: true },
      ];
      this.items = data.items;
      this.items.forEach(el => {
        try {
          el.created && (el.created = moment(el.created.substring(0, 19), 'YYYY-MM-DD HH24:mm:SS').format('YYYY-MM-DD'));
        } catch (e) {
          console.warn(`Can't format date-time (${el.created}) for billing table`, e);
        }
      });
      this.rows = this.items.length;
    },
    saveRowsPerPage() {
      // Save the user's choice in localStorage
      localStorage.setItem('billingRowsPerPage', this.perPage);
    },
    getRowsPerPageFromStorage() {
      // Retrieve the saved rows per page from localStorage
      const savedRowsPerPage = localStorage.getItem('billingRowsPerPage');
      return savedRowsPerPage ? parseInt(savedRowsPerPage, 10) : this.perPage;
    },
  },
  async mounted() {
    try {
      const tariff_data = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/tariffs`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(tariff_data.data);
      this.tariff_table = {};
      tariff_data.data.items.forEach(el => {
        this.tariff_table[el.id] = el.description;
      });
    } catch (error) {
      console.log(error);
    }

    await this.updateTable();
    this.perPage = this.getRowsPerPageFromStorage();
  }
};
</script>
